//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import {contractGroupByContCateCode} from "@/api/contract/contract";

export default {
	data() {
		return {
			contractGroupByContCateCode: [], //根据合同类型进行分类
		}
	},
	created() {

	},
	computed: {},
	mounted: function() {
		this.loadContractGroupByContCateCode();
	},
	methods: {
		// 返回
		goback() {
			// 返回工作台
			this.$router.push({
				name: 'workbench'
			});
		},
		//根据条件获取每种项目类型的项目数量
		loadContractGroupByContCateCode(){
	        contractGroupByContCateCode().then(response => {
	        	// 数据赋值
          		for(let i = 0 ; i < response.length ; i++){
          			this.contractGroupByContCateCode.push(response[i]);
          		}
	        });
	    },
		//进入列表信息
		loadListData(contCateCode,contTypeCode){
			// 参数一：合同类别    
			// 参数二：合同类型
			this.$router.push({
				name: '合同列表',
				params: {
					gobackName: '合同总览',
					contCateCode: contCateCode,
					contTypeCode:contTypeCode
				}
			});
		}
	}
}



// WEBPACK FOOTER //
// ./src/view/contract/contractOverview.vue